import j from "react";
var u, p;
function d() {
  if (p) return u;
  p = 1;
  var s = Object.create, o = Object.defineProperty, f = Object.getOwnPropertyDescriptor, v = Object.getOwnPropertyNames, i = Object.getPrototypeOf, l = Object.prototype.hasOwnProperty, O = (e, r) => {
    for (var t in r)
      o(e, t, { get: r[t], enumerable: !0 });
  }, _ = (e, r, t, c) => {
    if (r && typeof r == "object" || typeof r == "function")
      for (let a of v(r))
        !l.call(e, a) && a !== t && o(e, a, { get: () => r[a], enumerable: !(c = f(r, a)) || c.enumerable });
    return e;
  }, y = (e, r, t) => (t = e != null ? s(i(e)) : {}, _(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    !e || !e.__esModule ? o(t, "default", { value: e, enumerable: !0 }) : t,
    e
  )), b = (e) => _(o({}, "__esModule", { value: !0 }), e), n = {};
  O(n, {
    useLayoutEffect: () => g
  }), u = b(n);
  var P = y(j), g = globalThis != null && globalThis.document ? P.useLayoutEffect : () => {
  };
  return u;
}
export {
  d as __require
};
